/**
 * useStudentTerminal
 *
 * Page-level state for the instructor's shell-into-student-pod modal.
 * Lives at the page level (rather than globally) so each page can decide
 * where to render the <StudentTerminal /> overlay. Both Environments.tsx
 * and StudentDetail.tsx instantiate this independently.
 */

import { useCallback, useState } from 'react';

export interface StudentTerminalTarget {
  environmentId: string;
  studentName: string;
  studentEmail: string;
}

export interface UseStudentTerminalReturn {
  isOpen: boolean;
  environmentId: string | null;
  studentInfo: { name: string; email: string } | null;
  open: (target: StudentTerminalTarget) => void;
  close: () => void;
}

export function useStudentTerminal(): UseStudentTerminalReturn {
  const [target, setTarget] = useState<StudentTerminalTarget | null>(null);

  const open = useCallback((next: StudentTerminalTarget) => {
    setTarget(next);
  }, []);

  const close = useCallback(() => {
    setTarget(null);
  }, []);

  return {
    isOpen: target !== null,
    environmentId: target?.environmentId ?? null,
    studentInfo: target ? { name: target.studentName, email: target.studentEmail } : null,
    open,
    close,
  };
}
